import { HR_HEALTHCARE_MODE } from "./constants";
import {
  DROP_DOWN_HEALTHCARE_CATEGORY_OPTIONS,
  HEALTHCARE_CATEGORY_LISTS,
  healthcareCategoryLookup,
} from "./healthcare/jobHealthcareCategories";
import {
  DROP_DOWN_INDUSTRY_OPTIONS,
  HEALTHCARE_INDUSTRY,
  INDUSTRY_LIST,
  jobIndustryLookup,
} from "../jobs/helpers/jobIndustries";
import sortBy from "lodash/sortBy";

export const CANDIDATE_CATEGORIES = [
  ...sortBy([...INDUSTRY_LIST, ...HEALTHCARE_CATEGORY_LISTS], "text").map(
    (item, index) => ({
      ...item,
      key: index + 1,
    })
  ),
].filter((i) => i.value !== HEALTHCARE_INDUSTRY);

export function getIndustryAndCategory(category) {
  return (
    jobIndustryLookup[category] ||
    healthcareCategoryLookup[category] ||
    category
  );
}

export function getJobFilterOptions(mode) {
  if (mode === HR_HEALTHCARE_MODE) {
    return DROP_DOWN_HEALTHCARE_CATEGORY_OPTIONS;
  } else {
    return DROP_DOWN_INDUSTRY_OPTIONS;
  }
}
